import { render, staticRenderFns } from "./form-design.vue?vue&type=template&id=7e583768&"
import script from "./form-design.vue?vue&type=script&lang=js&"
export * from "./form-design.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports